import { CustomSelect } from 'components';
import { CustomSelectProps } from 'components/CustomSelect/CustomSelect.props';
import useCompanyListOptions from 'pages/Waterfall/components/CompanyList/useCompanyListOptions';

const CompanyList = (props: CustomSelectProps) => {
  const { cell, onCommit, onRevert } = props;

  const { options } = useCompanyListOptions();

  return (
    <CustomSelect
      autoFocus
      id="company-list"
      menuPlacement="bottom"
      onCommit={onCommit}
      onEmptyValue=""
      onRevert={onRevert}
      openMenuOnFocus
      options={options}
      value={cell.value as string}
    />
  );
};

export default CompanyList;
